/* eslint-disable @typescript-eslint/naming-convention */

const abbreviationDictionary: Record<string, string> = {
    'Adjustment Factor': 'Adjmnt Factor',
    'Announcement Date': 'Anncmnt Date',
    'Bloomberg Symbol': 'Bloom Symbol',
    'Event Type': 'Type',
    'Delisting Exchange': 'Delist Exchange',
    'Delisting Reason': 'Delist Reason',
    'Dividend Currency': 'Div Currency',
    'Dividend Gross Amount': 'Div Gross Amnt',
    'Expected Earnings Date': 'Exp Earn Date',
    'Expected Earnings Status': 'Exp Earn Status',
    'Listing Exchange': 'List Exchange',
    'Security Type': 'Sec Type',
};

export function abbreviate(text: string): string {
    return abbreviationDictionary[text] ?? text;
}
